import { useEffect, useState } from 'react';
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Box, Tooltip, Typography, Checkbox, FormGroup } from '@mui/material';
import { checkApiStatus } from '../../../../utils';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { PageLoader } from '../../../../shared_elements';
import { addMembersApi, updatemembersApi } from '../apiService';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import AutocompleteCreatable from '../../../../shared_elements/components/AutocompleteCreatable';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const MembersCRU = ({ onToggleModal, membersCRU, wrkGrpSlug, modeType, fileUpload, getResponseBack, onOpenAttachments, sortInfo, getSortingWiseData }) => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const { storageDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(membersCRU?.data);
    const { enqueueSnackbar } = useSnackbar()
    const [attachments, setAttachments] = useState([]);
    const [dropDownLoader, setDropDownLoader] = useState({ constant: false, user: false })
    const [user, setUser] = useState([]);
    const spartaUser = user?.find(email => email === data?.email) || false;

    useEffect(() => {
        getUserList();
    }, [])

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const onFieldChange = (key, value) => {
        setData(prev => ({ ...prev, [key]: value, }));
        setError((prev) => ({ ...prev, [key]: '' }));

        // setError(prev => ({ ...prev, [key]: '', }));
        setError((prev) => ({ ...prev, [key]: '' }));
    };


    const getUserList = () => {
        setDropDownLoader(prev => ({ ...prev, user: true }));
        globalGetService('/api/dropdown/active-users')
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUser(response?.data?.data);
                }
                setDropDownLoader(prev => ({ ...prev, user: false }));
            })
    }

    const onAddEditMember = () => {
        let validationInputs = {};
        validationInputs = {
            first_name: data?.first_name ? "" : "Please enter First Name",
            mobile: data?.mobile?.trim()?.length ? regexConstants.phoneNumber.test(data?.mobile) ? '' : 'Please enter valid Phone number' : '',
            email: data?.email?.trim()?.length ? regexConstants.email.test(data?.email) ? '' : 'Please enter valid Email' : ''
        };

        let payload = Object.assign({}, data);
            payload = {
                ...payload,
                email: payload?.email ? payload?.email : null,
                default_mailer: spartaUser && data?.default_mailer ? true : false
            }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(updatemembersApi({ ...params, wrkGrpSlug: wrkGrpSlug, memberSlug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        if (sortInfo[wrkGrpSlug]?.sort) {
                            getSortingWiseData(sortInfo[wrkGrpSlug], wrkGrpSlug)
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Working Group Member`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Working Group Member`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                globalPostService(addMembersApi({ ...params, wrkGrpSlug: wrkGrpSlug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        if (sortInfo[wrkGrpSlug]?.sort) {
                            getSortingWiseData(sortInfo[wrkGrpSlug], wrkGrpSlug)
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Working Group Member`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Working Group Member`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Working Group Member`, error_msg: validationInputs, })
        }
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Working Group Member`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                // onClose={onToggleModal}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === 'add' ? 'Add Member' : modeType === 'edit' ? 'Edit Member' : 'View Member'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="first_name"
                                label="First Name"
                                variant="outlined"
                                size='small'
                                value={data?.first_name || ''}
                                error={!!error.first_name}
                                helperText={error.first_name}
                                fullWidth
                                required
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("first_name", value.trimStart()) : e.preventDefault() : null
                                }}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: {maxLength: 50}}}
                                disabled={modeType === 'view'}
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="last_name"
                                label="Last Name"
                                variant="outlined"
                                size='small'
                                fullWidth
                                value={data?.last_name || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("last_name", value.trimStart()) : e.preventDefault() : null
                                }}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 50} }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={data?.email?.length > 23 ? data?.email : ""} placement="bottom" arrow>
                                <span>
                                    <AutocompleteCreatable
                                        label="Email Address"
                                        multiple={false}
                                        options={user
                                            .map(email => ({ label: email, value: email }))
                                            .filter(opt => !data?.email || opt.value !== data.email.value)}
                                        value={data?.email || null}
                                        onFieldChange={(e, paramsKey, newValue) => onFieldChange('email', newValue?.label || "")}
                                        getOptionLabel={(option) => option.label}
                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        noOptionsText={dropDownLoader?.user ? 'Loading...' : 'No options, type to create'}
                                        loading={dropDownLoader?.user}
                                        loadingText="loading"
                                        placeholder="Enter Email"
                                        fullWidth
                                        isDisabled={modeType === "view"}
                                        error={error.email}
                                        helperText={error?.email || ''}
                                    />
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="mobile"
                                label="Mobile Number"
                                variant="outlined"
                                size='small'
                                fullWidth
                                value={data?.mobile || ''}
                                onChange={(e) => {
                                    regexConstants?.numberWithSpecChar?.test(e.target.value) || e.target.value === "" ? onFieldChange("mobile", e.target.value) : e.preventDefault()
                                }}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 10} }}
                                disabled={modeType === 'view'}
                                error={error.mobile}
                                helperText={error.mobile}
                                onFocus={() => { setError(prev => ({ ...prev, mobile: "" })); }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="designation"
                                label="Designation"
                                variant="outlined"
                                size='small'
                                fullWidth
                                value={data?.designation || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("designation", value.trimStart()) : e.preventDefault() : null
                                }}
                                slotProps={{ inputLabel: { shrink: true } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data?.remarks || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, remarks: "" }));
                                    }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        {spartaUser ?
                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormGroup className='disabled-checkbox-wrapper'>
                                        <Box className="check-item-div" sx={{ cursor: modeType === 'view' && 'not-allowed' }}>
                                            <Checkbox sx={{ paddingLeft: '0px' }} disabled={modeType === 'view'} disableRipple checked={data?.default_mailer === true ? true : false} onChange={(e) => onFieldChange("default_mailer", e.target.checked)} />
                                            <Typography className="check-item-span" fontSize='14px'>Default Mail Receiver</Typography>
                                        </Box>
                                    </FormGroup>
                                </Grid> : null}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {data?.id && data?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('View Attachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({membersCRU?.data?.attachments?.length})Attachment(s)</Button> : null
                                }
                                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' size='small' className='btn-primary' disabled={modeType === 'view'} onClick={() => { handleItemClicked('Save Button'); onAddEditMember(); }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"} </Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>

    )
}
export default MembersCRU